var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15.999,
  height: 16,
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#726855",
  d: "M6.806 4.637a.565.565 0 0 0-1.04 0C4.426 7.749 4.32 7.855 1.207 9.194a.566.566 0 0 0 0 1.04c3.112 1.336 3.22 1.444 4.557 4.557.197.46.844.46 1.041 0 1.336-3.111 1.443-3.218 4.557-4.556a.565.565 0 0 0 0-1.041C8.25 7.858 8.144 7.75 6.806 4.637"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "sparkle_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.453.655a.345.345 0 0 0-.622 0c-.552 1.143-.748 1.339-1.891 1.891a.345.345 0 0 0 0 .622c1.143.552 1.34.748 1.891 1.892.126.26.496.26.622 0 .553-1.144.749-1.34 1.892-1.892a.345.345 0 0 0 0-.622c-1.143-.552-1.34-.748-1.892-1.891"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#726855",
  strokeWidth: 4,
  d: "M15.345 3.168c-1.143.552-1.34.748-1.892 1.892a.345.345 0 0 1-.622 0c-.552-1.144-.748-1.34-1.891-1.892a.345.345 0 0 1 0-.622c1.143-.552 1.34-.748 1.891-1.891a.345.345 0 0 1 .622 0c.553 1.143.749 1.339 1.892 1.891.26.126.26.496 0 .622Z",
  mask: "url(#sparkle_svg__a)"
})));
export default SvgSparkle;